import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const ComplaintListDashboard = () => {
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchComplaints();
  }, []);

  const fetchComplaints = async () => {
    try {
      setLoading(true);
      const res = await axios.get("https://api.herracim.az/api/dashboard/complaints", {
        withCredentials: true,
      });
      setComplaints(res.data);
    } catch (err) {
      alert("❌ Şikayətləri yükləmək mümkün olmadı.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p>⏳ Yüklənir...</p>;

  return (
    <div className="complaints-list-dashboard">
      <h2>📋 Bütün Şikayətlər</h2>
      {complaints.length === 0 ? (
        <p>🚫 Şikayət yoxdur</p>
      ) : (
        <table className="complaints-table">
          <thead>
            <tr>
              <th>🆔 ID</th>
              <th>📦 Məhsul</th>
              <th>🧍‍♂️ Alıcı</th>
              <th>🏪 Satıcı</th>
              <th>📅 Tarix</th>
              <th>📌 Status</th>
              <th>🔍 Ətraflı</th>
            </tr>
          </thead>
          <tbody>
            {complaints.map((complaint) => (
              <tr key={complaint.id}>
                <td>{complaint.id}</td>
                <td>{complaint.productName}</td>
                <td>{complaint.buyerFullName}</td>
                <td>{complaint.sellerFullName}</td>
                <td>{new Date(complaint.createdAt).toLocaleDateString()}</td>
                <td><span className={`status ${complaint.status.toLowerCase().replace(" ", "-")}`}>{complaint.status}</span></td>
                <td>
                  <Link to={`/dashboard/complaints/${complaint.id}`}>🔗 Bax</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ComplaintListDashboard;
